import React, {memo} from 'react';
import {TextField} from '../../../../ui/molecules/field/textfield';
import {PasswordInputEyeToggle} from '../../../../ui/molecules/password-input-eye-toggle';
import {useMemberProfileHook} from '../member-profile-hooks';
import {
  CustomButton,
  SectionIntro,
  SecurityCard,
  SecurityFields,
  SecurityForm,
} from '../member-profile-style';

export const Security = memo(() => {
  const {
    submitPassword,
    passwordRegister,
    isDisabledPassword,
    isSubmittingPassword,
    passwordErrors,
    passwordHandleSubmit,
  } = useMemberProfileHook();

  return (
    <SecurityCard>
      <SectionIntro>
        <h2>Update your password</h2>
        <p>Choose a strong password that you don't use on other sites.</p>
      </SectionIntro>
      <SecurityForm
        method="patch"
        onSubmit={passwordHandleSubmit(submitPassword)}>
        <SecurityFields>
          <div>
            <TextField
              label="Current password"
              defaultValue=""
              placeholder="Current password"
              type="password"
              ref={passwordRegister}
              helper={passwordErrors.oldPassword?.message || ''}
              state={passwordErrors.oldPassword ? 'error' : 'default'}
              name="oldPassword"
              action={(ref) => {
                return <PasswordInputEyeToggle inputRef={ref} />;
              }}
            />
          </div>
          <div>
            <TextField
              label="New password"
              defaultValue=""
              placeholder="New password"
              type="password"
              ref={passwordRegister}
              helper={passwordErrors.newPassword?.message || ''}
              state={passwordErrors.newPassword ? 'error' : 'default'}
              name="newPassword"
              action={(ref) => {
                return <PasswordInputEyeToggle inputRef={ref} />;
              }}
            />
          </div>
          <CustomButton
            type="submit"
            width="full"
            disabled={isDisabledPassword}
            data-form-action={true}
            isLoading={isSubmittingPassword}
            aria-busy={isSubmittingPassword}>
            Save password
          </CustomButton>
        </SecurityFields>
      </SecurityForm>
    </SecurityCard>
  );
});
